import React, { useContext } from 'react'
import { Link } from "gatsby"
import { captureEvent } from 'event-service/modules/capture'
import { ModalVehicleContext } from '../modal/storage/VehicleContext'

import unavaiable from '../../images/rv-not-available.png'

import { IsNewDisplay, configurableString, configurableLink, configurableSlug,upperCaseInString } from '../../Modules/configurableVehicleInfo'

export default function VehicleRecommendation(props) {
  const { theSlug, item, formatPrice, SRPCardBtns } = props
  const { unavailableImg } = props
  const isFavorite = props.isFavorite || false
  const favorite = props.favorite || (() => { })
  const location = typeof window !== 'undefined' && window.location
  const fallbackText = props.fallbackText
  const showSpecs = props.showSpecs
  const showTrim = props.showTrim

  const [, setFinanceModalContext] = useContext(ModalVehicleContext)

  const contextualizeItem = () => {
    const { Pricing, VehicleInfo } = item
    const finalPrice = Number(Pricing.ExtraPrice1 || Pricing.List)
    const vehicleInfo = VehicleInfo
    setFinanceModalContext({ finalPrice, vehicleInfo })
  }

  function getStorageItem(item) {
    return (typeof localStorage.getItem !== 'undefined' ? localStorage.getItem(item) : "[]")
  }

  function setStorageItem(item, value) {
    typeof localStorage.setItem !== 'undefined'
      ? localStorage.setItem(item, value)
      : console.log('no localStorage')
  }

  const handleImgError = (event) => {
    event.target.onerror = null;
    event.target.src = unavailableImg
  }

  const showPhoto = () => {
    let mainPhoto = {}
    if (item.MainPhotoUrl === "") {
      mainPhoto = unavailableImg
    } else {
      mainPhoto = item.MainPhotoUrl;
    }
    return mainPhoto
  }

  const renderBtns = (btngroup) => (
    <div className="sr-btns">
      {SRPCardBtns.map((btngroup, index) => {
        let BtnStyle = btngroup.overrideTheme ? {
          background: btngroup.btncolor,
          border: '1px solid ' + btngroup.btntxtcolor,
          ":hover": {
            background: btngroup.btntxtcolor,
            border: '1px solid ' + btngroup.btncolor
          }
        } : {};
        let LinkStyle = btngroup.overrideTheme ? {
          color: btngroup.btntxtcolor,
          ":hover": { color: btngroup.btncolor }
        } : {};

        return <div className="sr-btns__wrap">
          {
            ((btngroup.btnleft !== "") && (btngroup.btnleftlink.includes('tel:')))
              ?
              <a className="sr-btns-item" style={BtnStyle} href={btngroup.btnleftlink}
              onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnleftlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                  contextualizeItem(item);
                  setStorageItem("vehicle:vehicle", item.VehicleInfo);
                  setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                }
                }>
                <span className="sr-btns-link" style={LinkStyle} >
                  {configurableString(btngroup.btnleft, item.VehicleInfo)}
                </span>
              </a>
              :
              (btngroup.btnleft == "")
                ?
                <></>
                :
                ((btngroup.btnleft !== "") && (btngroup.btnleftlink.includes('#')))
                  ?
                  <Link className="sr-btns-item" style={BtnStyle}
                    to={location.search + configurableString(btngroup.btnleftlink, item.VehicleInfo)}
                  onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnleftlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <span className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnleft, item.VehicleInfo)}
                    </span>
                  </Link>
                  :
                  <Link className="sr-btns-item" style={BtnStyle}
                    to={configurableLink(btngroup.btnleftlink, item.VehicleInfo)}
                  onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnleftlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnleftlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <span className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnleft, item.VehicleInfo)}
                    </span>
                  </Link>
          }
          {
            ((btngroup.btnright !== "") && (btngroup.btnrightlink.includes('tel:')))
              ?
              <a className="sr-btns-item" style={BtnStyle} href={btngroup.btnrightlink}
                onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                  contextualizeItem(item);
                  setStorageItem("vehicle:vehicle", item.VehicleInfo);
                  setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                }
                }>
                <span className="sr-btns-link" style={LinkStyle} >
                  {configurableString(btngroup.btnright, item.VehicleInfo)}
                </span>
              </a>
              :
              (btngroup.btnright == "")
                ?
                <></>
                :
                ((btngroup.btnright !== "") && (btngroup.btnrightlink.includes('#')))
                  ?
                  <Link className="sr-btns-item" style={BtnStyle}
                    to={location.search + configurableString(btngroup.btnrightlink, item.VehicleInfo)}
                    onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <span className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnright, item.VehicleInfo)}
                    </span>
                  </Link>
                  :
                  <Link className="sr-btns-item" style={BtnStyle} to={configurableString(btngroup.btnrightlink, item.VehicleInfo)}
                    onClick={event => {
                  captureEvent({
                      event: 'asc_cta_interaction',
                      element_text: `${event.currentTarget.innerText}`,
                      element_color: `${window.getComputedStyle(event.currentTarget).color}`,
                      element_type: 'button',
                      event_action: 'click',
                      event_action_result: `${btngroup.btnrightlink.startsWith("#") ? 'open form' : 'open'}`,
                      link_url: `${btngroup.btnrightlink}`,
                      item_id: item.VehicleInfo.VIN,
                      item_number: `${item.VehicleInfo.Year} ${item.VehicleInfo.Make} ${item.VehicleInfo.Model} ${item.VehicleInfo.Trim}`,
                      item_price: `${item.Pricing.ExtraPrice1}`,
                      item_condition: `${item.VehicleInfo.IsNew ? 'New' : 'Used'}`,
                      item_year: `${item.VehicleInfo.Year}`,
                      item_make: `${item.VehicleInfo.Make}`,
                      item_model: `${item.VehicleInfo.Model}`,
                      item_variant: `${item.VehicleInfo.Trim}`,
                      item_color: `${item.VehicleInfo.ExteriorColor}`,
                      item_type: 'vehicle',
                      item_category: `${item.VehicleInfo.BodyStyle}`,
                      item_fuel_type: `${item.VehicleInfo.EngineFuelType}`,
                      item_inventory_date: `${item.VehicleInfo.InStockDate}`
                    }, {
                      handlers: ['ASC']
                    }).then(res => console.log(res)).catch(err => console.log(err))
                      contextualizeItem(item);
                      setStorageItem("vehicle:vehicle", item.VehicleInfo);
                      setStorageItem("vehicle:price", (item.Pricing.ExtraPrice1 != 0 ? item.Pricing.ExtraPrice1 : "Call for Price"))
                    }
                    }>
                    <span className="sr-btns-link" style={LinkStyle} >
                      {configurableString(btngroup.btnright, item.VehicleInfo)}
                    </span>
                  </Link>
          }
        </div>
      })}
    </div >
  )

  const FLAGS = { msrp: 1, msrpSale: 2, sale: 4, both: 8 }

  const renderPrice = (msrp, sale) => {
    const toRender = 0
    if (msrp == 0 && sale == 0) {
      return toRender | FLAGS.both
    } else if (msrp == sale) {
      return toRender | FLAGS.msrp
    } else if (msrp > sale) {
      return toRender | FLAGS.msrpSale
    } else if (msrp < sale) {
      return toRender | FLAGS.sale
    }
  }

  const pricing = renderPrice(item.Pricing.List, item.Pricing.ExtraPrice1)

  return (
    <>
      <div className="sr-item-slider">
      <Link to={configurableSlug(theSlug, item.VehicleInfo)}>
          <img className="sr-item__img" src={showPhoto()} onError={handleImgError} />
          <div className="sr-item__more-btn">More Details</div></Link>
        <div className={`sr-item__like ${isFavorite && "sr-item__like_active"}`}
          onClick={() => favorite(item.VehicleInfo.VIN)} />
      </div>
      <Link to={configurableSlug(theSlug, item.VehicleInfo)}><div className="sr-item-content">
        <div className={"sr-item-content__upper " + (!showSpecs && " sr-item-content__nospecs")}>
          <h2 className="sr-item-content__header">
            <span className="sr-item-content__header sr-item-content_font-normal">{IsNewDisplay(item.VehicleInfo.IsNew) + " " + item.VehicleInfo.Year}</span> 
            {upperCaseInString(" " + item.VehicleInfo.Make + " " + item.VehicleInfo.Model,["2Wd","4Wd","Rav4","Ev6","Wrx","Jk"])}
            {showTrim && " " + item.VehicleInfo.Trim}
          </h2>
          <p className="sr-item-content__stock">
            <span className="sr-item-content_font-normal">Location:</span> <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.DealerName}</span>
            <br />
            <span className="sr-item-content_font-normal">VIN:</span> <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.VIN}</span>
            <br />
            <span className="sr-item-content_font-normal">Mileage:</span> <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Mileage}</span>
            &nbsp;&#9679;&nbsp;
            <span className="sr-item-content_font-normal">Stock #:</span> <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.StockNumber}</span>
          </p>
          { showSpecs &&
          <p className="sr-item-content__specs">
            <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Drivetrain}</span>, <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Transmission}</span>, <span className="sr-item-content_font-normal sr-item-content-value">{item.VehicleInfo.Engine}</span>
          </p>
          }    
        </div>

        {!item.VehicleInfo.IsNew ?
          <div className="sr-item-content__costs">
            <div className="sr-item-content__costs-new-cost">
              <h3 className="sr-item-content__cost-header">Net Cost</h3>
              <p className="sr-item-content__cost">
                {formatPrice(item.Pricing.ExtraPrice1, fallbackText)}
              </p>
            </div>
          </div>
          :
          <div className="sr-item-content__costs">
            {Boolean(pricing & FLAGS.both) && (<p className="sr-item-content__cost">{fallbackText}</p>)}
            {Boolean(pricing & FLAGS.msrp || pricing & FLAGS.msrpSale) &&
              <div className="sr-item-content__costs-msrp">
                <h3 className="sr-item-content__cost-header">MSRP</h3>
                <p className="sr-item-content__cost" style={{ fontSize: "1em", opacity: "0.55" }}>
                  {formatPrice(item.Pricing.List, fallbackText)}
                </p>
              </div>
            }
            {Boolean(pricing & FLAGS.sale || pricing & FLAGS.msrpSale) &&
              <div className="sr-item-content__costs-msrp">
                <h3 className="sr-item-content__cost-header">Net Cost</h3>
                <p className="sr-item-content__cost" style={{ fontSize: "1em", opacity: "0.55" }}>
                  {formatPrice(item.Pricing.ExtraPrice1, fallbackText)}
                </p>
              </div>
            }
          </div>
        }

      </div>
      </Link>
      {renderBtns(item)}
    </>
  )
}

VehicleRecommendation.defaultProps = {
  unavailableImg: unavaiable
}
